<template>
  <div>
    <v-app-bar
      app
      elevation="0"
      dense
      :class="['py-md-16 bg-black position-relative', { 'rounded-pill': mdAndUp }]"
    >
      <v-toolbar
        dense
        color="transparent"
        elevation="0"
        :class="['bg-grey-darken-4 mx-auto px-4', { 'rounded-pill': mdAndUp }]"
        style="max-width: 1262px"
      >
        <v-app-bar-nav-icon
          variant="text"
          @click.stop="drawer = !drawer"
          class="white--text hidden-md-and-up"
        />
        <div class="w-100 d-flex justify-space-between">
          <button
            @click.stop="drawer = !drawer"
            class="white--text hidden-md-and-up"
          >
            <!-- <svg
              width="30"
              height="25"
              viewBox="0 0 30 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                y="6"
                width="24"
                height="3"
                rx="1.5"
                fill="white"
              />
              <rect
                y="13.5"
                width="24"
                height="3"
                rx="1.5"
                fill="white"
              />
              <rect
                y="21"
                width="24"
                height="3"
                rx="1.5"
                fill="white"
              />
            </svg> -->
          </button>
          <v-toolbar-title
            class="white--text cursor-pointer d-flex justify-start pl-md-0 pl-4 d-md-block"
          >
            <div
              class=""
              style="font-size: 32px"
            >
              <router-link
                to="/"
                class="text-decoration-none text-grey-darken-1 d-flex align-center ga-2"
              >
                <HeaderLogo />
                <OmegusPrimeQurani />
              </router-link>
            </div>
          </v-toolbar-title>
        </div>
        <v-spacer />
        <v-toolbar-items
          class="hidden-sm-and-down"
          style=""
        >
          <HeaderComponentLink :to="{ name: 'default' }">Home</HeaderComponentLink>
          <HeaderComponentLink
            :to="{ name: 'services' }"
            :class="{ 'v-btn--active': isServicesActive() }"
          >
            Services
          </HeaderComponentLink>
          <HeaderComponentLink :to="{ name: 'about' }">About Us</HeaderComponentLink>
          <HeaderComponentLink :to="{ name: 'contact' }">Contact Us</HeaderComponentLink>
        </v-toolbar-items>
      </v-toolbar>
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      color="grey-darken-4"
    >
      <v-list dense>
        <v-list-item
          :to="{ name: 'default' }"
          exact
        >
          <v-list-item-title class="white--text">Home</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{ name: 'services' }"
          :class="{
            'v-btn--active':
              typeof route.name === 'string' &&
              (route.name === 'services' || route.name.startsWith('servicedetail')),
          }"
          exact
        >
          <v-list-item-title class="white--text">Services</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{ name: 'about' }"
          exact
        >
          <v-list-item-title class="white--text">About Us</v-list-item-title>
        </v-list-item>
        <v-list-item
          :to="{ name: 'contact' }"
          exact
        >
          <v-list-item-title class="white--text">Contact Us</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script setup lang="ts">
  import HeaderLogo from '@/assets/SvgIcons.vue/HeaderLogo.vue';
  import OmegusPrimeQurani from '@/assets/SvgIcons.vue/OmegusPrimeQurani.vue';
  import { ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useDisplay } from 'vuetify';
  import HeaderComponentLink from './HeaderComponentLink.vue';
  const drawer = ref(false);
  const route = useRoute();
  const { mdAndUp } = useDisplay();
  function isServicesActive() {
    const name = route.name ?? '';
    if (typeof name === 'string') {
      return name === 'services' || name.startsWith('servicedetail');
    }
    return false;
  }
</script>
<style scoped>
  .v-btn.v-btn--active span {
    color: white !important;
    border-bottom: 1px solid white;
  }
.v-btn.v-btn--active {
    background-color:#020202;
    border-radius: 30px;
  }
.v-btn.v-btn--hover {
    background-color:transparent;
    transition: none;
  }
</style>
